import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-travel-wages',
  templateUrl: './travel-wages.component.html',
  styleUrls: ['./travel-wages.component.css']
})
export class TravelWagesComponent implements OnInit {
    public setting?: Setting;

    public itemsListTravelWages: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1488))[0];
    }

    private async loadTravelWages() {
        this.itemsListTravelWages = await this.datatask.Post(1487);
    }

    private async init() {
        this.loadSetting();
        this.loadTravelWages();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    filtervalue: string;
}
